import { Region } from '@moonpig/web-core-types'
import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

const conciergeDictionary = {
  'concierge_chat.modal_title': {
    'en-GB': `AI Mode`,
    'nl-NL': 'AI-modus',
  },
  'concierge_chat.modal_description': {
    'en-GB': 'AI Mode chat modal',
    'nl-NL': 'AI-modus chatvenster',
  },
  'search.concierge_btn': {
    'en-GB': 'AI Mode',
    'nl-NL': 'AI-modus',
  },
  'concierge_chat.header_title': {
    'en-GB': `AI Mode`,
    'nl-NL': 'AI-modus',
  },
  'concierge_chat.header_menu_label': {
    'en-GB': `Chat menu`,
    'nl-NL': 'Chatmenu',
  },
  'concierge_chat.header_menu_option_start_new': {
    'en-GB': `Start new chat`,
    'nl-NL': 'Nieuwe chat',
  },
  'concierge_chat.input_placeholder': {
    'en-GB': `Tell us what you're looking for...`,
    'nl-NL': 'Vertel ons wat je zoekt...',
  },
  'concierge_chat.input_label': {
    'en-GB': `Your message`,
    'nl-NL': `Jouw bericht`,
  },
  'concierge_chat.input_submit_label': {
    'en-GB': `Send message`,
    'nl-NL': `Bericht versturen`,
  },
  'concierge_chat.input_disclaimer_text': {
    'en-GB': `AI powers this chat. Please do not share sensitive information. Find out
        more in our`,
    'nl-NL': `AI ondersteunt deze chat. Deel geen gevoelige informatie. Lees meer in onze…`,
  },
  'concierge_chat.input_disclaimer_privacy_policy': {
    'en-GB': `Privacy Policy`,
    'nl-NL': 'Privacyverklaring',
  },
  'concierge_chat.input_disclaimer_privacy_policy_url': {
    'en-GB': ({ region }: { region: Region }) => `/${region}/privacy-notice/`,
    'nl-NL': ({ region }: { region: Region }) =>
      `/${region}/voorwaarden/privacy-reglement-greetz/app/`,
  },
  'concierge_chat.error_message': {
    'en-GB':
      'Oops, something went wrong on our end. To continue, please tap the three dots above and restart the chat.',
    'nl-NL':
      'Hmmm, er ging bij ons iets niet helemaal goed. Tik op de drie stipjes bovenaan om een nieuwe chat te beginnen.',
  },
  'concierge_chat.add_to_basket_success': {
    'en-GB': 'Item added to your basket',
    'nl-NL': 'Artikel toegevoegd aan je winkelmandje',
  },
  'concierge_chat.intro_title': {
    'en-GB': 'How can I help you today?',
    'nl-NL': 'Hoe kan ik je vandaag helpen?',
  },
  'concierge_chat.intro_greeting': {
    'en-GB': ({ firstName }: { firstName: string }) => `Hi ${firstName}!`,
    'nl-NL': ({ firstName }: { firstName: string }) => `Hoi ${firstName}!`,
  },
  'concierge_chat.help_page_link': {
    'en-GB': 'Go to Help Page',
    'nl-NL': 'Ga naar de helppagina',
  },
  'concierge_chat.product_modal_description': {
    'en-GB': 'AI Mode product details',
    'nl-NL': 'AI-modus omschrijving',
  },
  'concierge_chat.suggestions_screen_reader_hint': {
    'en-GB': 'Choose one of the following options.',
    'nl-NL': 'Kies een van deze mogelijkheden.',
  },
  'concierge_chat.quick_prompts_title': {
    'en-GB': 'Suggestions',
    'nl-NL': 'Suggesties',
  },
  'concierge_chat.products_carousel_title': {
    'en-GB': 'Recommendations',
    'nl-NL': 'Aanbevelingen',
  },
  'concierge_chat.thinking_title': {
    'en-GB': 'Thinking...',
    'nl-NL': 'Thinking...',
  },
  'concierge_chat.sample_question_1': {
    'en-GB': 'I want to find a funny cat card for my sister’s birthday',
    'nl-NL':
      'Ik zoek een grappige kaart met katten erop voor de verjaardag van mijn zus',
  },
  'concierge_chat.sample_question_2': {
    'en-GB': 'Show me your best Lego for adults!',
    'nl-NL': 'Laat lego voor volwassen zien',
  },
  'concierge_chat.sample_question_3': {
    'en-GB':
      'I’ve got £100 to spend on a colleague’s leaving card and gift - what can I get him?',
    'nl-NL':
      'Ik zoek een kaart en cadeau voor een collega die afscheid neemt, maximaal € 100',
  },
  'concierge_chat.error_modal_description': {
    'en-GB': 'AI Mode error screen',
    'nl-NL': 'Foutscherm van AI-modus',
  },
  'concierge_error_screen.title': {
    'en-GB': 'AI Mode is currently unavailable.',
    'nl-NL': 'AI-modus is op dit moment niet beschikbaar.',
  },
  'concierge_error_screen.text': {
    'en-GB': 'But don’t worry, you can still explore our cards and gifts!',
    'nl-NL': 'Maar je kunt de cadeaus en kaarten nog gewoon bekijken!',
  },
  'concierge_error_screen.close_button': {
    'en-GB': 'Close',
    'nl-NL': 'Sluiten',
  },
  'concierge_error_screen.close_button_aria_label': {
    'en-GB': 'Close chat',
    'nl-NL': 'Chat sluiten',
  },
  'concierge_chat.loading_label': {
    'en-GB': 'Loading conversation',
    'nl-NL': 'Gesprek laden',
  },
  'concierge_chat.screen_reader_assistant_label': {
    'en-GB': 'Moonpig Assistant:',
    'nl-NL': 'Moonpig Assistant:',
  },
  'concierge_chat.view_card_label': {
    'en-GB': 'View card',
    'nl-NL': 'Bekijk kaart',
  },
}

export const useLocaleText = createLocaleTextHook({
  dictionary: conciergeDictionary,
})
